/**
 * @generated SignedSource<<0f020679f950a2fc99a55c619045506f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalViewQuery$variables = {
  containerId: string;
  isNavRefreshEnabled: boolean;
  key: string;
  teamTql?: string | null;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalViewQuery$data = {
  readonly goal: {
    readonly key: string;
    readonly name: string;
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly parentGoals: {
      readonly count: number;
    } | null;
    readonly subGoals: {
      readonly count: number;
    } | null;
    readonly uuid: string;
    readonly watchers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly aaid: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalArchivedPanel" | "GoalCompletePanel" | "GoalContent" | "GoalHeader" | "GoalMetaActions" | "GoalSidebar" | "GoalTabs" | "useRedirectToDefaultGoalTab">;
  } | null;
  readonly workspaceGoalTypes: {
    readonly goalTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "GoalType";
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"metricInfoSectionNewLozenge">;
};
export type GoalViewQuery = {
  response: GoalViewQuery$data;
  variables: GoalViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamTql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v5 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": (v14/*: any*/)
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = [
  (v11/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "concreteType": "UserEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v17/*: any*/)
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "archived"
},
v20 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v21 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v22 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v23/*: any*/)
},
v25 = {
  "kind": "ScalarField",
  "name": "score"
},
v26 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v27 = {
  "kind": "ScalarField",
  "name": "value"
},
v28 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v24/*: any*/),
    (v27/*: any*/),
    (v25/*: any*/)
  ]
},
v29 = [
  (v21/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "label"
},
v31 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v32 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v30/*: any*/),
  (v24/*: any*/),
  {
    "alias": "tooltip",
    "args": (v31/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v31/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v23/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v33 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "ScalarField",
  "name": "picture"
},
v35 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v36 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "type"
},
v38 = [
  (v37/*: any*/),
  {
    "kind": "ScalarField",
    "name": "percentage"
  }
],
v39 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v38/*: any*/)
},
v40 = [
  (v27/*: any*/),
  (v16/*: any*/)
],
v41 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v40/*: any*/)
},
v42 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v43 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v44 = {
  "kind": "ScalarField",
  "name": "subType"
},
v45 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v46 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v47 = {
  "concreteType": "ProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        {
          "concreteType": "ProjectPhaseDetails",
          "kind": "LinkedField",
          "name": "newPhase",
          "plural": false,
          "selections": [
            {
              "alias": "_id",
              "kind": "ScalarField",
              "name": "id"
            }
          ]
        },
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v11/*: any*/),
            (v36/*: any*/)
          ]
        },
        (v10/*: any*/),
        (v9/*: any*/),
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v33/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v30/*: any*/),
            (v24/*: any*/),
            {
              "alias": "projectStateValue",
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "CompletionProjectState",
              "kind": "LinkedField",
              "name": "atCompletionState",
              "plural": false,
              "selections": [
                (v27/*: any*/),
                (v30/*: any*/),
                (v24/*: any*/)
              ]
            },
            (v27/*: any*/)
          ]
        },
        (v19/*: any*/),
        {
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            (v18/*: any*/)
          ]
        }
      ]
    },
    (v46/*: any*/)
  ]
},
v48 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connectionId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "ari"
},
v50 = {
  "kind": "ScalarField",
  "name": "watching"
},
v51 = {
  "kind": "ScalarField",
  "name": "description"
},
v52 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v53 = {
  "concreteType": "Metric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v9/*: any*/),
    (v37/*: any*/),
    (v44/*: any*/),
    (v19/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v55 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v56 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v57 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v54/*: any*/),
            (v49/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v55/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v34/*: any*/),
                    (v9/*: any*/),
                    (v56/*: any*/),
                    (v35/*: any*/)
                  ]
                },
                (v16/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v46/*: any*/)
  ]
},
v58 = [
  (v9/*: any*/)
],
v59 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v60 = {
  "kind": "ScalarField",
  "name": "summary"
},
v61 = {
  "kind": "ScalarField",
  "name": "title"
},
v62 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v60/*: any*/),
    (v16/*: any*/)
  ]
},
v63 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v64 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v65 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v66 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v67 = [
  (v16/*: any*/)
],
v68 = [
  (v10/*: any*/),
  (v16/*: any*/)
],
v69 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v70 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "requiresParentGoal"
},
v72 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v27/*: any*/)
      ],
      "type": "GoalTypeCustomName"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v22/*: any*/),
        {
          "kind": "ScalarField",
          "name": "defaultValue"
        }
      ],
      "type": "LocalizationField"
    }
  ]
},
v73 = {
  "concreteType": "GoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v10/*: any*/)
  ]
},
v74 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v75 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v76 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/),
        (v51/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v75/*: any*/)
  ]
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v78 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v79 = [
  (v78/*: any*/)
],
v80 = {
  "kind": "InlineFragment",
  "selections": (v79/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v81 = {
  "kind": "InlineFragment",
  "selections": (v79/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v80/*: any*/),
        (v81/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v83 = [
  (v16/*: any*/),
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalViewQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "goal",
        "args": (v7/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "parentGoals",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          (v15/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "GoalArchivedPanel"
          },
          {
            "kind": "FragmentSpread",
            "name": "GoalCompletePanel"
          },
          {
            "kind": "FragmentSpread",
            "name": "GoalHeader"
          },
          {
            "kind": "FragmentSpread",
            "name": "GoalTabs"
          },
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalMetaActions"
              },
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "teamTql",
                    "variableName": "teamTql"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "GoalSidebar"
              }
            ]
          },
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContent"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "useRedirectToDefaultGoalTab"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "metricInfoSectionNewLozenge"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalViewQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "goal",
        "args": (v7/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v17/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v13/*: any*/)
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "parentGoals",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v10/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v19/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v20/*: any*/),
                      (v9/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v33/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v36/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      (v39/*: any*/),
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v44/*: any*/),
                                      (v16/*: any*/),
                                      (v19/*: any*/)
                                    ]
                                  },
                                  (v16/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v45/*: any*/),
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v46/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      }
                    ]
                  }
                ]
              },
              (v48/*: any*/)
            ]
          },
          (v16/*: any*/),
          {
            "concreteType": "GoalState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v25/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "targetDate"
          },
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v20/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "learningsCount"
          },
          {
            "kind": "ScalarField",
            "name": "risksCount"
          },
          {
            "kind": "ScalarField",
            "name": "decisionsCount"
          },
          (v51/*: any*/),
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v16/*: any*/),
              (v52/*: any*/),
              {
                "concreteType": "UserCapabilities",
                "kind": "LinkedField",
                "name": "currentUserAppCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Capability",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "capability"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                      },
                      (v16/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v39/*: any*/),
          {
            "concreteType": "MetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "MetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "MetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v41/*: any*/),
                      (v53/*: any*/),
                      (v16/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v57/*: any*/),
          {
            "concreteType": "GoalPhaseDetails",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v58/*: any*/)
          },
          (v59/*: any*/),
          {
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v54/*: any*/),
              (v55/*: any*/),
              (v60/*: any*/),
              (v62/*: any*/),
              (v16/*: any*/)
            ]
          },
          {
            "alias": "latestUpdates",
            "args": [
              (v63/*: any*/)
            ],
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v55/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "updates(first:1)"
          },
          {
            "concreteType": "DraftUpdate",
            "kind": "LinkedField",
            "name": "draftUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "input"
              },
              {
                "kind": "ScalarField",
                "name": "modifiedDate"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v9/*: any*/),
                      (v34/*: any*/)
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v46/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "args": (v66/*: any*/),
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v55/*: any*/),
                      (v16/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v49/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v52/*: any*/)
                            ]
                          },
                          (v50/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v67/*: any*/)
                          },
                          (v10/*: any*/),
                          (v9/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v55/*: any*/),
                              (v54/*: any*/),
                              (v60/*: any*/),
                              (v62/*: any*/)
                            ]
                          },
                          (v59/*: any*/),
                          (v15/*: any*/),
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      (v43/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v16/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v9/*: any*/),
                              (v56/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v64/*: any*/),
                      (v65/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v21/*: any*/),
                          (v24/*: any*/),
                          (v28/*: any*/)
                        ]
                      },
                      (v49/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v40/*: any*/)
                                  },
                                  (v53/*: any*/),
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v40/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v38/*: any*/)
                      },
                      (v57/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v58/*: any*/)
                          },
                          (v16/*: any*/)
                        ]
                      },
                      (v54/*: any*/),
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v32/*: any*/)
                      },
                      (v60/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v8/*: any*/),
                          (v61/*: any*/),
                          (v60/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v32/*: any*/)
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      {
                        "concreteType": "GoalPhaseDetails",
                        "kind": "LinkedField",
                        "name": "newPhase",
                        "plural": false,
                        "selections": (v58/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": (v68/*: any*/)
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ]
                  },
                  (v69/*: any*/)
                ]
              },
              (v70/*: any*/)
            ],
            "storageKey": "updates(first:10)"
          },
          {
            "args": (v66/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "args": (v45/*: any*/),
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v47/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v19/*: any*/),
          {
            "condition": "isNavRefreshEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "parentGoal",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v39/*: any*/),
                  {
                    "concreteType": "MetricTargetConnection",
                    "kind": "LinkedField",
                    "name": "metricTargets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "MetricTargetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "MetricTarget",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              {
                                "concreteType": "Metric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/),
                                  (v44/*: any*/),
                                  (v16/*: any*/),
                                  (v9/*: any*/),
                                  (v19/*: any*/)
                                ]
                              },
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              },
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": (v58/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v15/*: any*/),
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v71/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v46/*: any*/)
                ]
              },
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canLinkToFocusArea"
                  },
                  {
                    "concreteType": "GoalTypeConnection",
                    "kind": "LinkedField",
                    "name": "allowedParentTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v49/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v71/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "GoalTypeConnection",
                    "kind": "LinkedField",
                    "name": "allowedChildTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v49/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v71/*: any*/),
                              (v16/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v71/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/)
                ]
              },
              {
                "concreteType": "TagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v51/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "goalUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "helpPointerUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": "tagConnectionId",
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "MetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "MetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "Metric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMembers"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v34/*: any*/),
                      (v56/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      },
                      (v35/*: any*/)
                    ]
                  }
                ]
              },
              {
                "args": (v74/*: any*/),
                "concreteType": "GoalTeamConnection",
                "kind": "LinkedField",
                "name": "teamsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTeamEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "teamId"
                          },
                          (v9/*: any*/),
                          (v16/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "TeamDetails",
                            "kind": "LinkedField",
                            "name": "teamDetails",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "avatarUrl"
                          },
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "tql",
                                "variableName": "teamTql"
                              }
                            ],
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": (v14/*: any*/)
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canRemove"
                      },
                      (v69/*: any*/)
                    ]
                  },
                  (v70/*: any*/),
                  (v46/*: any*/)
                ],
                "storageKey": "teamsV2(first:20)"
              },
              {
                "args": (v74/*: any*/),
                "handle": "connection",
                "key": "Goal__teamsV2",
                "kind": "LinkedHandle",
                "name": "teamsV2"
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              (v55/*: any*/),
              {
                "concreteType": "CustomFieldConnection",
                "kind": "LinkedField",
                "name": "customFields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CustomFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v76/*: any*/),
                              {
                                "concreteType": "CustomFieldTextSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "alias": "textValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v82/*: any*/)
                            ],
                            "type": "TextCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v76/*: any*/),
                              {
                                "concreteType": "CustomFieldNumberSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "alias": "numberValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v82/*: any*/)
                            ],
                            "type": "NumberCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      (v51/*: any*/),
                                      (v78/*: any*/)
                                    ],
                                    "type": "UserCustomFieldDefinition"
                                  },
                                  (v75/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "concreteType": "UserPII",
                                            "kind": "LinkedField",
                                            "name": "pii",
                                            "plural": false,
                                            "selections": [
                                              (v34/*: any*/),
                                              (v9/*: any*/),
                                              (v56/*: any*/),
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "ExtendedProfile",
                                                "kind": "LinkedField",
                                                "name": "extendedProfile",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v48/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v81/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "UserCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      (v51/*: any*/),
                                      (v78/*: any*/),
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "allowedValues",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextAllowedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v83/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomFieldDefinition"
                                  },
                                  (v75/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CustomFieldTextSavedValueConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v83/*: any*/)
                                      }
                                    ]
                                  },
                                  (v48/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v80/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "TextSelectCustomField"
                          },
                          (v75/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "keys": [
                    "GOALS_METRICS_POPUP"
                  ]
                }
              },
              (v63/*: any*/)
            ],
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              {
                "concreteType": "OnboardingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Onboarding",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v68/*: any*/)
                  }
                ]
              }
            ],
            "storageKey": "onboarding(filter:{\"keys\":[\"GOALS_METRICS_POPUP\"]},first:1)"
          },
          (v16/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3ee3935cca0759258ce19f7099963963",
    "id": null,
    "metadata": {},
    "name": "GoalViewQuery",
    "operationKind": "query",
    "text": "query GoalViewQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $teamTql: String\n  $isNavRefreshEnabled: Boolean!\n  $containerId: String!\n) {\n  workspaceGoalTypes: townsquare {\n    goalTypes(containerId: $containerId) {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    uuid\n    name\n    key\n    owner {\n      aaid\n      id\n    }\n    watchers {\n      edges {\n        node {\n          aaid\n          id\n        }\n      }\n    }\n    parentGoals {\n      count\n    }\n    subGoals {\n      count\n    }\n    ...GoalArchivedPanel\n    ...GoalCompletePanel\n    ...GoalHeader\n    ...GoalTabs\n    ...GoalMetaActions @skip(if: $isNavRefreshEnabled)\n    ...GoalSidebar_1QTvbf @skip(if: $isNavRefreshEnabled)\n    ...GoalContent @include(if: $isNavRefreshEnabled)\n    ...useRedirectToDefaultGoalTab\n    id\n  }\n  ...metricInfoSectionNewLozenge\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment DraftGoalUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n        newValue {\n          value\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  uuid\n  summary\n  newPhase {\n    name\n  }\n  newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    uuid\n    id\n  }\n  goal {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment EditableGoalUpdateCard on GoalUpdate {\n  id\n  goal {\n    id\n  }\n  creationDate\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...GoalUpdateCard\n  ...EditGoalUpdate\n}\n\nfragment EmptyStateNoUpdates on Goal {\n  watching\n  canPostUpdate\n}\n\nfragment FollowersSidebarSection on UserConnection {\n  count\n  edges {\n    node {\n      pii {\n        name\n        picture\n        accountId\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection_GoalKey on Goal {\n  key\n}\n\nfragment FollowersSidebarSection_Owner on UserPII {\n  accountId\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GoalAboutTab on Goal {\n  id\n  description\n  ...GoalDescription\n  ...GoalProgressChart\n  ...GoalComments\n}\n\nfragment GoalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalArchivedPanel on Goal {\n  id\n  state {\n    value\n  }\n}\n\nfragment GoalComments on Goal {\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment GoalCompletePanel on Goal {\n  state {\n    value\n  }\n}\n\nfragment GoalContent on Goal {\n  key\n  ari\n  userUpdateCount\n  canEditUpdate\n  watching\n  ...GoalAboutTab\n  ...GoalUpdatesTab\n  ...GoalProjectsTab\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalDescription on Goal {\n  id\n  uuid\n  description\n  canPostUpdate\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalHeader on Goal {\n  id\n  name\n  ...GoalIcon\n  ...GoalHeaderBreadcrumbs\n  ...GoalStateAndTargetDate\n  ...PlatformGoalIcon\n}\n\nfragment GoalHeaderBreadcrumbs on Goal {\n  parentGoals {\n    edges {\n      node {\n        id\n        key\n        name\n      }\n    }\n  }\n}\n\nfragment GoalIcon on Goal {\n  state {\n    score\n    value\n  }\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalOwner on Goal {\n  id\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProgressChart on Goal {\n  progress {\n    type\n  }\n  ...MetricChart\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalProjectsTab on Goal {\n  projects(tql: \"archived = false\", first: 200) {\n    count\n  }\n  subGoals {\n    count\n  }\n  ...GoalProjects\n  ...GoalSubGoals\n}\n\nfragment GoalSidebar_1QTvbf on Goal {\n  ari\n  id\n  key\n  goalType {\n    id\n    canLinkToFocusArea\n  }\n  tags {\n    ...Tags\n  }\n  ...parentGoalTypeRestrictions_GoalSidebar\n  ...subGoalTypeRestrictions_GoalSidebar\n  ...metricInfoSection\n  ...GoalOwner\n  ...ParentGoal\n  ...SubGoals\n  ...Teams_1QTvbf\n  ...FollowersSidebarSection_GoalKey\n  ...GoalStartDate\n  ...GoalType\n  customFields {\n    ...SidebarFields\n  }\n  watchers {\n    ...FollowersSidebarSection\n  }\n  owner {\n    pii {\n      ...FollowersSidebarSection_Owner\n    }\n    id\n  }\n}\n\nfragment GoalStartDate on Goal {\n  startDate\n  ...GoalStartDatePicker\n}\n\nfragment GoalStartDatePicker on Goal {\n  id\n  startDate\n  targetDate\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment GoalTabs on Goal {\n  id\n  key\n  ari\n  watching\n  userUpdateCount\n  canEditUpdate\n  learningsCount\n  risksCount\n  decisionsCount\n  ...GoalAboutTab\n  ...GoalUpdatesTab\n  ...GoalProjectsTab\n  ...useUserHasCapabilitiesFromGoal\n}\n\nfragment GoalTeamByline_1QTvbf on Team {\n  teamId\n  projects(tql: $teamTql) {\n    count\n  }\n}\n\nfragment GoalType on Goal {\n  goalType {\n    ...goalTypeName\n    ...PlatformGoalTypeIcon\n    id\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateComposer on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate\n  ...AddToMissedUpdateMessage\n  draftUpdate {\n    ...DraftGoalUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesTab on Goal {\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalUpdateComposer\n  ...UpdatesList\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NewGoalUpdate on Goal {\n  id\n  uuid\n  key\n  workspace {\n    uuid\n    id\n    aiConfig {\n      enabled\n    }\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n}\n\nfragment ParentGoal on Goal {\n  id\n  ari\n  parentGoal {\n    id\n    archived\n    ...GoalItem\n  }\n  goalType {\n    requiresParentGoal\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment PlatformGoalTypeIcon on GoalType {\n  icon {\n    key\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment RemoveTeam on GoalTeamEdge {\n  canRemove\n  node {\n    teamId\n    id\n  }\n}\n\nfragment RollupMetricForm on Goal {\n  subGoals {\n    edges {\n      node {\n        archived\n        ...GoalName\n        id\n      }\n    }\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment SubGoals on Goal {\n  id\n  ari\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalItem\n        goalType {\n          requiresParentGoal\n          id\n        }\n      }\n    }\n  }\n  ...GoalSubGoals\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamAvatarWithFollowButton on Team {\n  id\n  teamId\n  name\n  watching\n  ...TeamAvatar\n}\n\nfragment Teams_1QTvbf on Goal {\n  id\n  key\n  canEditMembers\n  teamsV2(first: 20) {\n    edges {\n      node {\n        teamId\n        name\n        ...TeamAvatarWithFollowButton\n        ...GoalTeamByline_1QTvbf\n        id\n        __typename\n      }\n      ...RemoveTeam\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesList on Goal {\n  canEditUpdate\n  updateStreak\n  ...EmptyStateNoUpdates\n  updates(first: 10) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableGoalUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment inlineCurrentValueUpdate on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        metric {\n          id\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSection on Goal {\n  id\n  uuid\n  ...hasMetric\n  ...metricInfoSectionContent\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...inlineCurrentValueUpdate\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  ...metricInfoSectionEmptyState\n  ...progressText\n  ...hasMetric\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        id\n      }\n    }\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionEmptyState on Goal {\n  id\n  uuid\n  ...RollupMetricForm\n}\n\nfragment metricInfoSectionNewLozenge on Query {\n  currentUser {\n    onboarding(first: 1, filter: {keys: [GOALS_METRICS_POPUP]}) {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment metricTargetPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment parentGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedParentTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment progressText on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment subGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useRedirectToDefaultGoalTab on Goal {\n  watching\n  key\n}\n\nfragment useUserHasCapabilitiesFromGoal on Goal {\n  workspace {\n    currentUserAppCapabilities {\n      capabilities {\n        capability\n        capabilityContainer\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c59bbf08c9fe12c9a705e3280ef4cb34";

export default node;
